import { SPACES } from '@shared/typings/enums';
import type { PageContext } from '@paypalcorp/ppcms-shared-modules';

export function overrideEntryPathForMPP(defaultPageContext) {
  const pageContext = defaultPageContext;

  const {
    cmsEngineContext: {
      app: {
        appEntryPoint = '',
      } = {},
    } = {},
    additionalContext: {
      preview = false,
      isReqFromMPP = false,
    } = {},
  } = pageContext;

  if (isReqFromMPP && preview?.enabled && appEntryPoint) {
    pageContext.cmsEngineContext.app.appEntryPoint = appEntryPoint.replace('/site', '/webapps/mpp');
  }
  return pageContext;
}

export function overridePageTheme(defaultPageContext: PageContext) {
  const pageContext = defaultPageContext;
  const {
    additionalContext: {
      spaceKey,
    },
    cmsEngineContext: {
      environment: {
        theme,
      },
    },
  } = pageContext;

  if (spaceKey === SPACES.PRIVACY_HUB) {
    pageContext.cmsEngineContext.environment.theme = theme || 'quantumLeap';
  }

  return pageContext;
}
